import {
  CREATE_AD_CAMPAIGN_START,
  CREATE_AD_CAMPAIGN_SUCCESS,
  CREATE_AD_CAMPAIGN_FAILED,
  FETCH_USER_AD_START,
  FETCH_USER_AD_SUCCESS,
  FETCH_USER_AD_FAILED,
  FETCH_USER_AD_START_BY_ID,
  FETCH_USER_AD_SUCCESS_BY_ID,
  FETCH_USER_AD_FAILED_BY_ID,
  FETCH_RECOMMENDED_AD_FOR_USER_START,
  FETCH_RECOMMENDED_AD_FOR_USER_SUCCESS,
  FETCH_RECOMMENDED_AD_FOR_USER_FAILED,
  PUBLISH_USER_AD_BY_ID_START,
  PUBLISH_USER_AD_BY_ID_SUCCESS,
  PUBLISH_USER_AD_BY_ID_FAILED,
  DELETE_USER_AD_BY_ID_START,
  DELETE_USER_AD_BY_ID_SUCCESS,
  DELETE_USER_AD_BY_ID_FAILED,
} from './ActionConstant';

// Create Ads user actions
export function createAdsStart(payload) {
  return {
    type: CREATE_AD_CAMPAIGN_START,
    payload,
  };
}

export function createAdsSuccess(payload) {
  return {
    type: CREATE_AD_CAMPAIGN_SUCCESS,
    payload,
  };
}

export function createAdsFailure(payload) {
  return {
    type: CREATE_AD_CAMPAIGN_FAILED,
    payload,
  };
}

// Fetch user ads actions
export function fetchUserAdsStart() {
  return {
    type: FETCH_USER_AD_START,
  };
}

export function fetchUserAdsSuccess(payload) {
  return {
    type: FETCH_USER_AD_SUCCESS,
    payload,
  };
}

export function fetchUserAdsFailure(payload) {
  return {
    type: FETCH_USER_AD_FAILED,
    payload,
  };
}

//fetch user AD details by ID
export function fetchUserAdByIdStart(payload) {
  return {
    type: FETCH_USER_AD_START_BY_ID,
    payload,
  };
}

export function fetchUserAdByIdSuccess(payload) {
  return {
    type: FETCH_USER_AD_SUCCESS_BY_ID,
    payload,
  };
}

export function fetchUserAdByIdFailure(payload) {
  return {
    type: FETCH_USER_AD_FAILED_BY_ID,
    payload,
  };
}

export function fetchRecommendedAd(payload) {
  return {
    type: FETCH_RECOMMENDED_AD_FOR_USER_START,
    payload,
  };
}

export function fetchRecommendedAdSuccess(payload) {
  return {
    type: FETCH_RECOMMENDED_AD_FOR_USER_SUCCESS,
    payload,
  };
}

export function fetchRecommendedAdFailure(payload) {
  return {
    type: FETCH_RECOMMENDED_AD_FOR_USER_FAILED,
    payload,
  };
}

//publish user AD by ID
export function publishUserAdByIdStart(payload) {
  return {
    type: PUBLISH_USER_AD_BY_ID_START,
    payload,
  };
}

export function publishUserAdByIdSuccess(payload) {
  return {
    type: PUBLISH_USER_AD_BY_ID_SUCCESS,
    payload,
  };
}

export function publishUserAdByIdFailure(payload) {
  return {
    type: PUBLISH_USER_AD_BY_ID_FAILED,
    payload,
  };
}

//delete AD by ID
export function deleteAdById(payload) {
  return {
    type: DELETE_USER_AD_BY_ID_START,
    payload,
  };
}

export function deleteAdByIdSuccess(payload) {
  return {
    type: DELETE_USER_AD_BY_ID_SUCCESS,
    payload,
  };
}

export function deleteAdByIdFailure(payload) {
  return {
    type: DELETE_USER_AD_BY_ID_FAILED,
    payload,
  };
}
